export default __webpack_public_path__ + "static/media/Foxtail-Lily_R1.0d1c49d7.png";